import { ApiClient } from 'src/api/client/ApiClient'
import { apiOps } from 'src/api/defs/apiOps'
import { ClientUser } from 'src/api/defs/ClientUser.type'

export class UserApi {
    constructor(private api: ApiClient) {}

    current = (): Promise<ClientUser> => this.api.do(apiOps.ClientUser.current)
}
